class OrderModel {
    id: any
    token: string = ""
    clientId: any
    payLater: any
    paymentChannel: string = ""
    status: string = ""
    totalAmount: number = 0
    totalDeliveryCost: number = 0
    totalStorageCost: number = 0
    express: boolean = false
    pickup: boolean = false
    deliveryNote: string | null = null
    expressFee: number | null = null
    expressZone: string | null = null
    itemsDeliveryCost: number = 0
    items: any[] = []
    deliveries: OrderDelivery[] = []
    payments: any[] = []
    hasBankPayment: boolean = false
    town: string = ""
    district: string = ""
    unit: string = ""
    street: string = ""
    reserveUntil: Date = new Date()
    reserveDate: string = ""
    showItems: boolean = false
    createdAt: Date = new Date()
    createdAtStr = ""
    createdBy = ""
    ownName = ""
    parentName = ""
    companyId: any
    companyName = ""
    companyRegister = ""
    companyPhone = ""
    email = ""
    phone = ""
    store = 0
    guest = 0
    method = ""
    orderPhone = ""
    company: CompanyModel = new CompanyModel()
  }

  class CompanyModel {
    district: string = ""
    name: string = ""
    phone: string = ""
    register: string = ""
    street: string = ""
    town: string = ""
    unit: string = ""
  }

  class OrderDelivery {
    id: any
    orderId: any
    date: any
    cost: Number = 0
    papaCost: Number = 0
    deliveryProvider: string = "OWN"
    externalDeliveryId: string = ""
    externalDeliveryCode: string = ""
    externalDeliveryStatus: string = ""
    externalDeliveryError: string = ""
    items: any[] = []
}

export default OrderModel